import { filterObject } from "./filterObject";

describe("filterObject", () => {
    it("filters undesired keys", () => {
        const data = { test: "test", bad: "unwanted", cool: "yay" };
        expect(filterObject(data, ["bad"])).toMatchObject({
            test: data.test,
            cool: data.cool
        });
    });
});
